var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("h2", { staticClass: "titulo-the-home" }, [
        _vm._v("Bem-Vindo ao módulo de relatórios!")
      ]),
      _c(
        "el-row",
        {
          staticClass: "cards-mod",
          attrs: { type: "flex", justify: "center", gutter: 30 }
        },
        _vm._l(_vm.menu, function(funcionalidade) {
          return _c(
            "el-col",
            {
              key: funcionalidade.codigo,
              staticClass: "card-mod",
              nativeOn: {
                click: function($event) {
                  return _vm.redirecionaFuncionalidade(funcionalidade.routeName)
                }
              }
            },
            [
              _c("el-card", { staticClass: "center" }, [
                _c(
                  "div",
                  {
                    staticClass: "center",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [
                    _c("img", {
                      staticClass: "func-card",
                      attrs: { src: _vm.imgFuncionalidades(funcionalidade.img) }
                    })
                  ]
                ),
                _c("span", [_vm._v(_vm._s(funcionalidade.nome))])
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-591a29df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591a29df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/Home.vue
// module id = null
// module chunks = 